import { render, staticRenderFns } from "./ModalPostulatedEntities.vue?vue&type=template&id=c7a677ee"
import script from "./ModalPostulatedEntities.vue?vue&type=script&lang=js"
export * from "./ModalPostulatedEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports